import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import TrainingsEditTab from './Elements/TrainingsEditTab';
import TrainingMattersTab from './Elements/TrainingMattersTab';
import TeamTrainingsTab from './Elements/TeamTrainingsTab';

class TrainingsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      training_data: {},
      turmas: {},
      materias: {},
      lista_materias: {},
      lista_targets: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  refreshTable (responseJson) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/treinamentos');
        if (responseJson.status === 'success') {
          self.setState({training_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/buscar_materias/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({materias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/materias/lista/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_materias: responseJson.data});
        }
      }).then(() => {
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }); /* Overlay */}); /* Lista Materiais */ }); /* Materiais */
    });
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/treinamentos');
        if (responseJson.status === 'success') {
          self.setState({training_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/publico_alvo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_targets: responseJson.data,});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/buscar_turmas/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({turmas: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/buscar_materias/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({materias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/materias/lista/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_materias: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */}); /* Lista Materiais */ }); /* Materiais */ }); /* Turmas */}); /* Lista público alvo */
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Edição de treinamento - {this.state.training_data.name} - Carga horária: {this.state.training_data.hours_total_time}</h3>
      <Link to="/treinamentos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Dados do treinamento">
          <TrainingsEditTab handleAlert={this.handleAlert} training_data={this.state.training_data} training_id={this.props.match.params.id} lista_targets={this.state.lista_targets} />
        </Tab>
        <Tab eventKey={2} title="Matérias">
          <TrainingMattersTab handleAlert={this.handleAlert} refreshTable={this.refreshTable} materias={this.state.materias} lista_materias={this.state.lista_materias} training_hours_total={this.state.training_data.hours_total} training_id={this.props.match.params.id} />
        </Tab>
      </Tabs>      
    </div>
  </div>
</div>
    );
  }
}

export default TrainingsEdit;



// WEBPACK FOOTER //
// ./src/Components/Trainings/TrainingsEdit.js